import React from 'react'

import CircleLeftIcon from '../../icons/CircleLeftIcon'

import { useBreakpoint } from '../../../providers/BreakpointProvider'
import useStyles from './styles'

interface PageContentProps {
  hideIcon?: boolean
  toggleView: () => void
  children: React.ReactNode
}

const PageContent: React.FC<PageContentProps> = ({
  hideIcon,
  toggleView,
  children
}) => {
  const { isSmall } = useBreakpoint()

  const classes = useStyles()

  return (
    <div id='pageContent' className={classes.root}>
      {isSmall && !hideIcon && (
        <CircleLeftIcon onClick={() => toggleView()} className={classes.back} />
      )}

      {children}
    </div>
  )
}

export default PageContent
